import styled from "styled-components"
import { Box } from "@components/Layout"
import { Paragraph, Link, Anchor } from "@components/Typography"

export const Wrapper = styled(Box)`
  display: block;
  width: 100%;
  background: ${(p) => p.theme.colors.card.default};
  padding: 1.5rem;
  margin-top: 1rem;
`

export const Description = styled(Paragraph)`
  margin-bottom: 1rem;
`
export const InstagramLogo = styled(Box)`
  display: flex;
  align-items: center;
  margin-right: 1rem;
`
export const TextAndArrow = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const Content = styled(Anchor)`
  display: flex;
  align-items: center;
  width: 100%;

  &:hover {
    :after {
      width: 0 !important;
    }
    span:after {
      width: 100% !important;
    }
  }

  svg {
    height: 1.5rem;
    width: 1.5rem;
    fill: ${(p) => p.theme.colors.text.dark};
    transition: transform 0.25s ease-in-out;
  }
`

export const InstagramButton = styled(Link)`
  color: ${(p) => p.theme.colors.text.dark};
`
